import { Link } from 'types/api.types';
import { useIsMounted } from 'app/utils/hooks';
import { ImageStatusType } from 'types/enums';

export const useImageUploadPolling = (
  request: () => Promise<{ status: ImageStatusType }>
) => {
  const isMounted = useIsMounted();

  const pollImageUpload = async (
    pollingLink: Link,
    resolve: (status: { success: boolean }) => void,
    reject: (reason?: any) => void
  ) => {
    const { expires } = pollingLink;
    if (expires && expires < Math.floor(Date.now() / 1000)) {
      return;
    }
    if (pollingLink && pollingLink.pollingInterval) {
      setTimeout(async () => {
        if (!isMounted()) {
          return;
        }
        try {
          const { status } = await request();
          if (
            status === ImageStatusType.PROCESSING ||
            status === ImageStatusType.READY_FOR_UPLOAD
          ) {
            await pollImageUpload(pollingLink, resolve, reject);
            return;
          }
          if (status === ImageStatusType.SUCCESS) {
            resolve({ success: true });
            return;
          }
          if (status === ImageStatusType.FAILURE) {
            resolve({ success: false });
          }
        } catch (e) {
          reject(e);
        }
      }, pollingLink.pollingInterval * 1000);
    }
  };

  return (pollingLink: Link) =>
    new Promise<{ success: boolean }>((resolve, reject) => {
      pollImageUpload(pollingLink, resolve, reject);
    });
};
